// extracted by css-extract-rspack-plugin
export default {"lightBlue":"#a3bffc","infoIcon":"gEOc9m9zAYEJQowt__infoIcon___","label":"pYoC911r0n4LxXp8__label___"};